import { createAsyncThunk } from '@reduxjs/toolkit';

import { getLogger } from 'app-components/utils/core';

import { wellnessScoreApi } from './wellnessScoreApi';
import { toWellnessScoreRequestError } from './wellnessScoreErrors';
import {
  WELLNESS_SCORE_REDUCER_KEY,
  type WellnessScore,
  type WellnessScoreFulfilledMeta,
  type WellnessScoreRequest,
  type WellnessScoreRequestError,
} from './wellnessScoreTypes';

const log = getLogger('app-components/flux/wellness-score/wellnessScoreThunks');

export const fetchWellnessScore = createAsyncThunk<
  WellnessScore,
  WellnessScoreRequest,
  { rejectValue: WellnessScoreRequestError; fulfilledMeta: WellnessScoreFulfilledMeta }
>(`${WELLNESS_SCORE_REDUCER_KEY}/fetchWellnessScore`, async (request, { fulfillWithValue, rejectWithValue }) => {
  try {
    log.info('Requesting wellness score', { request });
    const score = await wellnessScoreApi.fetchWellnessScore(request);
    log.info('Wellness score fetched successfully', { request });
    return fulfillWithValue(score, { fetchedAt: new Date().toISOString() });
  } catch (error: unknown) {
    const requestError = toWellnessScoreRequestError(error);
    if (requestError.kind === 'schema') {
      // The response envelope itself is unusable; entry-level mismatches are logged where they are parsed.
      log.error('Wellness score response does not match the expected contract', { issues: requestError.issues });
    }
    return rejectWithValue(requestError);
  }
});
